/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Copia'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Nome'
  },
  LABEL: {
    FILTER_MONTH_APR: 'Aprile',
    FILTER_MONTH_AUG: 'Agosto',
    FILTER_MONTH_DEC: 'Dicembre',
    FILTER_MONTH_FEB: 'Febbraio',
    FILTER_MONTH_JAN: 'Gennaio',
    FILTER_MONTH_JUL: 'Luglio',
    FILTER_MONTH_JUN: 'Giugno',
    FILTER_MONTH_MAR: 'Marzo',
    FILTER_MONTH_MAY: 'Maggio',
    FILTER_MONTH_NOV: 'Novembre',
    FILTER_MONTH_OCT: 'Ottobre',
    FILTER_MONTH_SEP: 'Settembre',
    GENERATE_HASHTAG: 'Genera hashtag',
    GENERATE_LINK: 'Genera link',
    GENERATED_HASHTAG: 'Hashtag generato',
    GENERATED_LINK: 'Link generato',
    MONTH: 'Mese',
    NAME: 'Nome',
    YEAR: 'Anno'
  },
  SENTENCE: {
    NO_ROWS_PRODUCTS: 'Nessun prodotto',
    NO_ROWS_PRODUCTS_DESCRIPTION: 'Modifica i criteri di ricerca'
  },
  SUCCESS: {
    HASHTAG_COPIED: 'Hashtag copiato',
    LINK_COPIED: 'Link copiato'
  },
  TOOLTIP: {
    MONTH: 'Mese',
    NAME: 'Nome',
    YEAR: 'Anno'
  }
};
